import router from '../router'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import {auditLog} from 'api/common'
function getToken(key) {
  return localStorage.getItem(key);
}

router.beforeEach((to, from, next) => {
  NProgress.start(); // 开启Progress
  if (to.matched.some(record => record.meta.isStatic)) {
    if (getToken('sessionId')) {
      if (to.name === 'login' || to.name === 'loginForA') {
        router.app.eventBus && router.app.eventBus.$emit('reset-head');
        next({path: '/home'});
        NProgress.done()
      } else {
        next();
      }
    } else {
      auditLog().then(function (res) {
        if(res.title === '没有登录') {
          next();
        } else {
          localStorage.setItem('sessionId', res.data&&res.data.sessionId);
          localStorage.setItem('username', res.data&&res.data.userName);
          localStorage.setItem('userAccount', res.data&&res.data.userAccount);
          if (to.name === 'login' || to.name === 'loginForA') {
            next({path: '/home'});
          } else {
            next();
          }
          router.app.eventBus && router.app.eventBus.$emit('reset-head');
          NProgress.done();
        }
      });
    }
  } else {
    if (getToken('sessionId')) {
      next();
    } else {
      auditLog().then(function (res) {
        if(res.title === '没有登录') {
          next('/login');
        } else {
          localStorage.setItem('sessionId', res.data&&res.data.sessionId);
          localStorage.setItem('username', res.data&&res.data.userName);
          localStorage.setItem('userAccount', res.data&&res.data.userAccount);
          next();
        }
        router.app.eventBus && router.app.eventBus.$emit('reset-head');
        NProgress.done();
      });
    }
  }
});

router.afterEach(() => {
  NProgress.done()
});



// WEBPACK FOOTER //
// ./src/utils/permission.js